<template>
  <div class="Essay">
    <precautions :level="level" :unit="unit" v-if="selectedStep === 0 && questionData" :title="questionData.Name" />
    <div class="flex justify-center mt-5" v-if="selectedStep === 0">
      <a class="inline-block gept_main_bg4 text-white px-16 py-2 rounded-full mx-auto cursor-pointer font-bold" @click="getStart()">START</a>
    </div>
    <div v-if="selectedStep === 1" class="Essay_inner p-3 lg:p-6">
      <div class="flex justify-between items-center bg-white mb-2 essay-toolbar">
        <div class="flex items-center p-4">
          <h6 class="font-black text-left whitespace-pre-line">{{ writingDescription }}</h6>
        </div>

        <div class="flex items-center p-3">
          <div class="p-2 border-2 rounded m-1 gept_main_color10 border_main10 font-black essay-counter">已輸入 <span class="gept_main_color4">{{ textLength }}</span> 個單字</div>
          <div class="p-2 border-2 rounded m-1 gept_main_color4 border_main2 font-black essay-timer">{{ formatTime(answer_count) }}</div>
        </div>
      </div>
      <div class="writing_inner mb-3" v-if="qData">
        <div class="flex w-full essay-workspace" v-for="(item, index) in qData" :key="index">
          <div class="col w-1/2 p-2 essay-prompt-column">
            <div class="bg-white rounded overflow-hidden h-full essay-prompt-card">
              <div class="flex items-center justify-between gept_main_bg7">
                <div class="w-1/12"></div>
                <p class=" text-white text-center p-2 text-lg font-bold w-10/12">題目</p>
                <a v-if="getQuestionExplain(item)" class="tips p-2 rounded w-1/12 cursor-pointer" @click="alertTips(item)">
                  <img src="@/assets/image/gept/tips2.png" alt="" class=" object-contain block">
                </a>
              </div>

              <div class="p-4 h-full essay-prompt-body">
                <div class="mb-6 essay-title-block"><p class="text-xl font-semibold essay-title">{{ item.Title }}</p></div>
                <!-- <div class="mb-6 essay-title-block"><p class="text-xl font-semibold essay-title">{{ item.Description }}</p></div> -->
                <div class="essay-image-wrap"><img :src="item.ImageUrl" alt="" class="block essay-image"></div>
              </div>
            </div>
          </div>

          <div class="col w-1/2 p-2 essay-answer-column">
            <textarea v-model="textVal" :disabled="!isCanActive" name="textarea" id="textarea" cols="30" rows="15" class="bg-white w-full p-4 font-semibold leading-relaxed essay-textarea" placeholder="請作答 ..."></textarea>
          </div>
        </div>
      </div>
      <div class="flex justify-center essay-actions">
        <a class="inline-block gept_main_bg4 text-white px-16 py-2 rounded-full mx-3 cursor-pointer font-bold" @click="textVal = null">清除作答框</a>
        <a class="inline-block gept_main_bg5 text-white px-16 py-2 rounded-full mx-3 cursor-pointer font-bold" @click="toggleReport()">{{ !isLastGroup && $route.name === 'formal_exam' ? '前往下一個題型' : '交卷看報告' }}</a>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import precautions from '@/components/GEPT/precautions'
  import allJs from '@/components/all.js'
  import formal_examJs from '@/components/formal_exam.js'
  export default {
    name: 'Essay',

    data () {
      return {
        showfirstModal: false,
        isShowTitle: false,
        isCanActive: false, // 可以動作

        selectedStep: 0,
        questionNumber: 0, //第幾題

        timer: null,

        // 回答
        answer_count: 8,
        textVal: null,

        qData: null,
        spellCheck: null
      }
    },
    mixins: [
      allJs,
      formal_examJs
    ],
    props: {
      questionData: {
        type: Array
      },
      unitTitle: {
        type: String
      },
      unit: {
        type: String
      },
      isLastGroup: {
        type: Boolean,
        default: false
      },
      level: {
        type: String
      }
    },
    components: {
      precautions
    },
    computed: {
      textLength () {
        if (this.textVal) {
          let words = this.textVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").split(" ")
          let wordCount = words.filter(word => word.length > 0).length
          return wordCount
        }
        return 0
      },

      partDescription () {
        let part = Array.isArray(this.questionData) ? this.questionData[0] : this.questionData
        if (!part) return ''

        return part.Description || part.description || ''
      },

      writingDescription () {
        let currentWritingType = this.unit

        if (this.partDescription) return this.partDescription

        if (this.$route.name === 'quiz_practice_speaking') {
          if (currentWritingType === '中譯英') {
            return '請將以下中文句子翻譯成正確、通順、達意的英文。'
          }

          if (currentWritingType === '英文作文') {
            return '請依提示寫一篇英文作文，文長至少120個單詞。'
          }
        }

        return '請根據以下的圖片寫一篇約50字的短文。\n注意：未依提示作答者，將予扣分。'
      },

      spiltText () {
        if (this.textVal) {
          return this.textVal.split('')
        }
        return []
      }
    },
    mounted () {
    },
    methods: {
      getStart () {
        this.selectedStep = 1
        this.isCanActive = true
        this.setArray()
        this.stopWatch()
      },

      setArray () {
        if (this.questionData) {
          this.qData = this.questionData[0].Questions
        }
      },

      stopWatch () {
        let self = this
        self.timer = setInterval(() => {
            self.answer_count++

            if (self.answer_count >= 1 * 60 * 60) {
              clearInterval(self.timer)
              self.isCanActive = false
            }
          }, 1000
        )
      },

      formatTime (seconds) {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const secs = seconds % 60

        const formattedTime = [
            hours.toString().padStart(2, '0'),
            minutes.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0')
        ].join(':')

        return formattedTime
      },

      getQuestionExplain (item) {
        if (!item) return ''
        return item.explain || item.Explain || item.explanation || item.Explanation || ''
      },

      formatAlertHtml (text) {
        return String(text)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
          .replace(/\r?\n/g, '<br>')
      },

      alertTips (item) {
        let self = this
        let explain = self.getQuestionExplain(item)
        let defaultTips = '【段落寫作】這個部分的寫作採整體式的評分再轉換成百分制，需要花費的時間跟分數比重都較多，需要閱讀提示的文字用英文描寫出圖片情節約50字的短文，評分的重點包含文字表達完整度、文法、拼字、大小寫、標點符號等。<br/><br/>文章第一句可先說明全文主旨，接著內容依照時間順序描寫、切記不要離題或加入不相關的內容，中間善用轉折詞能讓文章結構更為清楚，最後結論可以加入自己對這件事的看法或感受。 試著用關鍵字先描述圖片中的動作或情節，注意時態是過去式或是現在式並且把3張圖片都串聯起來，把各個句子連接起來之後，要再注意文法上有沒有使用錯誤尤其是動詞時態、名詞單複數。'
        return self.$swal.fire({
          title: '作答提示',
          html: explain ? self.formatAlertHtml(explain) : defaultTips,
          showCloseButton: true,
          showConfirmButton: false,
          focusConfirm: false,
          showDenyButton: false,
          customClass: {
            container: '',
            popup: 'p-0 max-w-3xl w-full',
            header: 'py-5 text-white gept_main_bg',
            title: 'text-white m-0 text-2xl',
            closeButton: '',
            htmlContainer: 'p-4 font-bold leading-loose mb-6 text-left',
            actions: 'mb-4 mt-5',
            confirmButton: 'submitButton-gept',
            denyButton: 'denyButton-gept',
          }
        })
      },

      replaceString(item, index) {
        for (let value of this.spellCheck) {
          if (index >= value.offset && index < value.offset + value.token.length) {
            return true
          }
        }
        return false
      },

      // async submitReport () {
      //   if (this.textVal && await this.checkSubmitReport(this.unitTitle, this.questionData.Name)) {

      //     clearInterval(this.timer)

      //     this.getSpellCheck(this.textVal)
      //   }
      // },

      async toggleReport () {
        let self = this
        // eslint-disable-next-line
        let isGuideLink = (self.isLastGroup && self.$route.name === 'formal_exam') || (self.$route.name === 'practice_speaking') ? true : false
        let allAnswersFilled = self.textVal && self.textVal.trim() !== ""

        if (allAnswersFilled) {
          if (self.$route.name === 'practice_speaking' && await self.checkSubmitReport(self.unitTitle, self.questionData.Name)) {
            self.finish_exams(self.$route.query.record_id, self.questionData.Name, isGuideLink)
          } else if (self.$route.name === 'formal_exam') {
            let result
            let qId = self.qData[0].Id
            let Name = self.questionData[0].Name
            let Answer = self.textVal

            const checkPromise = new Promise(async(resolve, reject) => {
              result = await self.post_gept_records_byFormal(self.$route.query.record_id, qId, Name, Answer, null)

              if (result && !self.isLastGroup) {
                resolve(1)
                self.$emit('guideNextType')
              } else if (result && self.isLastGroup) {
                reject(2)
              }
            })

            checkPromise.then(() => {
              self.$emit('guideNextType')
            }, (fail) => {
              self.post_gept_records_finish(self.$route.query.record_id)
            })
          }
        } else {
          self.$swal.fire({
            title: '作答提示',
            html: '<p>尚有句子未完成</p>',
            showCloseButton: false,
            showConfirmButton: false,
            focusConfirm: false,
            showDenyButton: false,
            customClass: {
              container: '',
              popup: 'p-0 max-w-xl w-full',
              header: 'py-5 text-white gept_main_bg',
              title: 'text-white m-0 text-2xl',
              closeButton: '',
              htmlContainer: 'p-6 font-bold leading-loose text-center text-lg',
              actions: 'mb-4 mt-5',
              confirmButton: 'submitButton-gept',
              denyButton: 'denyButton-gept',
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.Essay {
  .Essay_inner {
    .essay-toolbar {
      gap: 0.5rem;
    }
    .essay-counter,
    .essay-timer {
      white-space: nowrap;
    }
    .essay-title {
      line-height: 1.5;
      overflow-wrap: anywhere;
    }
    .essay-image-wrap {
      text-align: center;
    }
    .essay-image {
      margin: 0 auto;
      max-height: 520px;
      object-fit: contain;
    }
    .essay-textarea {
      line-height: 1.55;
      resize: vertical;
    }
    .essay-actions {
      flex-wrap: wrap;
      gap: 0.75rem;
    }    .col {
      flex: 1;
    }
    .item-outer2 {

    }
    .item-outer3 {
    }
    .active {

    }

    .item_border_arrow_active{
      &:after {
        background-image: url('~@/assets/image/gept/arrow_active.jpg') !important;
      }
    }
    .item_img {
      min-height: 320px;
      .check {
        top: 45%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
    @media (max-width: 767.98px) {
      & {
        padding: 0.75rem !important;
      }
      .essay-toolbar {
        align-items: flex-start;
        flex-wrap: wrap;
        padding: 0.75rem !important;
      }
      .essay-toolbar h6 {
        font-size: 1rem;
        line-height: 1.65;
      }
      .essay-counter,
      .essay-timer {
        font-size: 0.95rem;
      }
      .essay-workspace {
        flex-direction: column;
      }
      .essay-prompt-column,
      .essay-answer-column {
        padding: 0.4rem 0 !important;
        width: 100% !important;
      }
      .essay-prompt-card {
        height: auto !important;
      }
      .essay-prompt-body {
        padding: 1rem !important;
      }
      .essay-title-block {
        margin-bottom: 1rem !important;
      }
      .essay-title {
        font-size: 1.05rem;
        line-height: 1.55;
      }
      .essay-image {
        max-height: 460px;
        max-width: 100%;
      }
      .essay-textarea {
        font-size: 1rem;
        min-height: 320px;
        padding: 1rem !important;
      }
      .essay-actions {
        gap: 0.75rem;
        padding-bottom: 0.5rem;
      }
      .essay-actions > a {
        flex: 1 1 0;
        line-height: 1.35;
        max-width: 220px;
        min-width: 135px;
        padding-left: 1rem !important;
        padding-right: 1rem !important;
        text-align: center;
        white-space: normal;
      }
    }    .item_text {
      min-height: 120px;
      height: 20%;
    }

  }
}
</style>
